import { styled } from '@mui/material/styles';
import { TABLET_MAX_WIDTH_PX } from '@/lib/constants';

export const AppShell = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: TABLET_MAX_WIDTH_PX,
  margin: '0 auto',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative',
}));

export const OutlineContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'centered',
})<{ centered?: boolean }>(({ centered }) => ({
  padding: 16,
  margin: '0 auto',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  textAlign: centered ? 'center' : undefined,
}));

export const JourneyPage = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const JourneyContent = styled('div')({
  width: '100%',
  marginBottom: 65,
});

export const ContentBlock = styled('div')({
  color: 'rgba(0, 0, 0, 0.87)',
  '& strong': {
    fontWeight: 500,
  },
});

export const StickyFooter = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  maxWidth: TABLET_MAX_WIDTH_PX,
  margin: '0 auto',
  padding: '5px 16px 76px',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.background.default,
  zIndex: 1,
}));

export const StaticFixedButton = styled('div')({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  maxWidth: TABLET_MAX_WIDTH_PX,
  margin: '0 auto',
  padding: '12px 16px 16px',
  boxSizing: 'border-box',
  background: 'linear-gradient(rgba(242, 242, 242, 0) 0%, #f2f2f2 40%)',
  zIndex: 2,
});

export const FlexCenter = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
});
